function toStatusFormatter(value: number) {

    // Pending = 0,
    // Scheduled = 1,
    // Actioned = 2,
    // Invoiced = 3,
    // Completed = 4,
    switch (value) {
      case 0:
        return 'Pending';
        break;
      case 1:
        return 'Scheduled';
        break;

      case 2:
        return 'Actioned';
        break;

      case 3:
        return 'Invoiced';
        break;

      case 4:
        return 'Completed';
        break;

      case 5:
        return 'Cancelled';
        break;

      case 6:
        return 'Invoiced No Charge';
        break;

        
      default:
        return '???';
        break;
    }

  
}

export default toStatusFormatter;
